module.exports = __webpack_public_path__ + "img/dexknows.8665f328.png";